import { useState, useEffect } from 'react';
import { marketsAPI } from '../api';

const css = `
.ticker-wrap{background:#0F1F38;border:1px solid rgba(0,194,255,0.12);border-radius:12px;padding:18px 22px;margin-bottom:28px;}
.ticker-head{display:flex;align-items:center;gap:10px;margin-bottom:14px;}
.ticker-label{font-size:11px;letter-spacing:2px;text-transform:uppercase;color:#1E7FD4;font-weight:600;}
.ticker-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:8px;}
@media(max-width:900px){.ticker-grid{grid-template-columns:repeat(4,1fr);}}
@media(max-width:560px){.ticker-grid{grid-template-columns:repeat(2,1fr);}}
.ticker-card{background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.05);border-radius:8px;padding:10px 12px;transition:all 0.2s;}
.ticker-card.sel{border-color:rgba(0,194,255,0.4);background:rgba(0,194,255,0.05);}
.tc-market{font-size:13px;font-weight:600;color:#F0F6FF;margin-bottom:2px;}
.tc-service{font-size:10px;color:#556677;margin-bottom:6px;text-transform:uppercase;letter-spacing:0.5px;}
.tc-rate{font-family:'Barlow Condensed',sans-serif;font-size:22px;font-weight:800;color:#1E7FD4;}
.tc-range{font-size:10px;color:#445566;margin-top:2px;}
`;

export default function MarketTicker({ selectedMarketId }) {
  const [rates, setRates] = useState([]);
  useEffect(() => {
    marketsAPI.rates().then(r => setRates(r.data)).catch(()=>{});
    const t = setInterval(() => marketsAPI.rates().then(r => setRates(r.data)).catch(()=>{}), 60000);
    return () => clearInterval(t);
  }, []);

  return (<><style>{css}</style>
    <div className="ticker-wrap">
      <div className="ticker-head">
        <span className="live-dot" />
        <span className="ticker-label">Live Market Rates — Data Center Hands & Feet</span>
      </div>
      <div className="ticker-grid">
        {rates.slice().sort((a,b)=>a.market_name.localeCompare(b.market_name)).map(r => (
          <div key={r.market_id} className={`ticker-card${selectedMarketId==r.market_id?' sel':''}`}>
            <div className="tc-market">{r.market_name?.split(',')[0]}</div>
            <div className="tc-service">Hands & Feet</div>
            <div className="tc-rate">${parseFloat(r.rate_avg).toFixed(0)}<span style={{fontSize:12,fontWeight:400,color:'#8899AA'}}>/hr</span></div>
            <div className="tc-range">${parseFloat(r.rate_low).toFixed(0)} – ${parseFloat(r.rate_high).toFixed(0)}/hr range</div>
          </div>
        ))}
        {rates.length === 0 && [1,2,3,4,5,6,7].map(i=>(
          <div key={i} className="ticker-card" style={{opacity:0.3}}>
            <div className="tc-market">Loading...</div><div className="tc-rate">—</div>
          </div>
        ))}
      </div>
    </div></>);
}
